// extracted by mini-css-extract-plugin
export default {"wtnBoxStyles":"wtnTeamBox_wtnBoxStyles__tIZnE","wtnStyles":"wtnTeamBox_wtnStyles__alXco"};